// Standalone entry: promo served from its own origin at its own document root. The embedded
// counterpart is webshell-main.js.

import createPromoApp from './create-app';
import { STYLE_SCOPE_CLASS } from './src/js/webshell-embed/embedded';

// Promo's global stylesheet is prefixed with this class at build time. Standalone it goes on <body>,
// so `#app` is inside it; embedded, the shell's host element carries it instead.
document.body.classList.add(STYLE_SCOPE_CLASS);

createPromoApp({ mountTarget: '#app' });
